import React from 'react';
import PageBase from 'components/PageBase';
import DefaultTable from 'components/Tables/DefaultTable';
import StatusSwitch from 'components/StatusSwitch';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as InterestListCreators } from 'store/ducks/interest/list';
import { Creators as InterestDeleteCreators } from 'store/ducks/interest/delete';
import { Creators as GlobalsStyleCreators } from 'store/ducks/globalsStatus/actions';
import { Paper } from '@material-ui/core';
import HeaderComponent from 'components/HeaderComponent';
import InterestTableHeader from 'components/Pages/InterestPage/InterestTableHeader';
import InterestActions from 'components/Pages/InterestPage/InterestActions';
// import InterestStatus from 'containers/Pages/InterestPage/InterestStatus';
import AlertDialog from 'components/AlertDialog';

const columns = ({ onDeleteRequest, changeStatus }) => [
  {
    title: 'Referência',
    field: 'id',
    sorting: false,
  },
  {
    title: 'Nome',
    field: 'name',
    sorting: false,
  },
  {
    title: 'Status',
    sorting: false,
    render: rowData => (
      <StatusSwitch
        changeStatus={changeStatus}
        rowData={rowData}
        item={rowData.status}
      />
    ),
  },
  {
    title: 'Ações',
    render: rowData => (
      <InterestActions rowData={rowData} onDeleteRequest={onDeleteRequest} />
    ),
  },
];

const InterestListPage = () => {
  const dispatch = useDispatch();
  const [deleteState, setDeleteState] = React.useState({
    open: false,
    item: {},
  });

  const [localState, setLocalState] = React.useState({
    search: '',
    orderByColumn: '',
    orderByDirection: '',
    page: 1,
    perPage: 10,
  });

  const { interestList, interestListLoading, interestListTotal } = useSelector(
    state => state.interest.list,
  );

  const { interestDeleteLoading } = useSelector(state => state.interest.delete);

  React.useEffect(() => {
    dispatch(InterestListCreators.getInterestListRequest(localState));
  }, []);

  const handleAlertDialogClose = () => {
    setDeleteState({ open: false, item: {} });
  };

  React.useEffect(() => {
    if (interestDeleteLoading === false && deleteState.open) {
      handleAlertDialogClose();
    }
  }, [interestDeleteLoading]);

  const getFunction = data => {
    setLocalState(oldLocalState => ({ ...oldLocalState, ...data }));
  };

  React.useEffect(() => {
    dispatch(InterestListCreators.getInterestListRequest(localState));
  }, [localState]);

  const onDeleteRequest = item => {
    setDeleteState({ open: true, item });
  };

  const onDeleteConfirm = () => {
    dispatch(
      InterestDeleteCreators.getInterestDeleteRequest(deleteState.item.id),
    );
  };

  const changeStatus = (e, id) => {
    const newStatus = e.target.checked;
    const data = {
      itemId: id,
      status: newStatus ? 1 : 0,
      name: 'user_interest',
    };

    dispatch(GlobalsStyleCreators.getRequest(data));
  };

  return (
    <PageBase>
      <HeaderComponent title="Listar Interesses">
        <InterestTableHeader
          getFunction={getFunction}
          initialValues={{ search: localState.search }}
        />
      </HeaderComponent>
      <Paper>
        <DefaultTable
          getFunction={getFunction}
          columns={columns({ onDeleteRequest, changeStatus })}
          data={interestList}
          total={interestListTotal}
          isLoading={interestListLoading}
          page={localState.page}
          perPage={localState.perPage}
        />
      </Paper>
      <AlertDialog
        isOpen={deleteState.open}
        isLoading={interestDeleteLoading}
        handleClose={handleAlertDialogClose}
        onConfirm={onDeleteConfirm}
        title="Excluir registro?"
        description={`Remover interesse: ${deleteState.item.name}`}
      />
    </PageBase>
  );
};

export default InterestListPage;
